/**
 * Форматирует идентификатор: если длина > 10, показывает первые 4 символа + "..." + последние 4 символа
 * @param {string|number} value - значение идентификатора
 * @returns {string} отформатированная строка
 */
export function formatIdentifier(value) {
  if (value === null || value === undefined) return "";
  const str = String(value);
  if (str.length <= 10) return str;
  return str.slice(0, 4) + "..." + str.slice(-4);
}
